import { render } from "./ExternalSearchResults.vue?vue&type=template&id=2ef8254e&ts=true"
import script from "./ExternalSearchResults.vue?vue&type=script&lang=ts"
export * from "./ExternalSearchResults.vue?vue&type=script&lang=ts"

import "./ExternalSearchResults.vue?vue&type=style&index=0&id=2ef8254e&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__